import { EquityTransactionsRegister } from '@/components/custom/companies/equity-transactions-register'
import { usePortalCompanyTransactions } from '@/hooks/use-portal'

export function PortalEquityTransactionsRegister() {
  const { data, isLoading } = usePortalCompanyTransactions({
    type: 'EQUITY_INVESTMENT',
    limit: 50,
  })

  return (
    <EquityTransactionsRegister rows={data?.data ?? []} isLoading={isLoading} />
  )
}
